export const ratePlansTab = {
  sectionLabel: {
    title: "Tarifas exibidas na reserva direta",
    hintHotel:
      "Escolha quais tarifas aparecem para cada tipo de quarto, sua ordem e a padrão.",
    hintApartment:
      "Escolha quais tarifas o hóspede vê, arraste para reordenar e marque a padrão.",
  },
  loading: "Carregando tarifas…",
  empty: {
    apartment: "Nenhuma tarifa configurada para esta propriedade.",
    hotel: "Nenhum tipo de quarto configurado para este hotel.",
    room: "Nenhuma tarifa configurada para este quarto.",
  },
  derivedPill: "Derivada",
  dragHandleTitle: "Arraste para reordenar",
  visibleSwitchTitle: "Exibir na reserva direta",
  expandTitleClose: "Fechar configurações",
  expandTitleOpen: "Definir nome, política e padrão",
  visibleNameLabel: "Nome de exibição",
  visibleNamePlaceholderApartment: "Ex.: Não reembolsável / Flexível",
  visibleNamePlaceholderHotel: "Ex.: Café da manhã incluído",
  cond: {
    refundable: "Pode ser cancelada",
    refundableHint: "Você decide até quando é grátis.",
    nonRefundable: "Não reembolsável",
    nonRefundableHint: "Não se devolve nada. O hóspede pode cancelar, mas paga 100%. Vê isto antes de pagar.",
    freeDays: "Cancelamento grátis até",
    freeDaysPlaceholder: "Sem limite",
    freeDaysHelp: "Dias antes da chegada. Vazio = grátis até o fim.",
    penalty: "Depois cobra-se",
    penaltyHelp: "Do total da estadia. 100% = não se devolve nada.",
    sinGuardar: "Esta tarifa ainda não tem condições guardadas. O que está abaixo é uma proposta: carregue em «Guardar política» para a aplicar.",
    aplicarTodas: "Aplicar a todos os quartos",
    aplicarTodasHelp: "A mesma condição será aplicada à tarifa «{name}» de mais 1 quarto. | A mesma condição será aplicada à tarifa «{name}» de mais {count} quartos.",
    notes: "Notas para o hóspede (opcional)",
    previewNonRefundable: "O hóspede lerá: «Esta tarifa não é reembolsável: a reserva não pode ser cancelada».",
    previewFree: "O hóspede lerá: «Cancelamento grátis até a chegada».",
    previewDayPenalty: "O hóspede lerá: «Cancelamento grátis até o dia da chegada; depois cobra-se {pct}%».",
    previewUntilPenalty: "O hóspede lerá: «Grátis até 1 dia antes; depois cobra-se {pct}%». | O hóspede lerá: «Grátis até {count} dias antes; depois cobra-se {pct}%».",
    shortNonRefundable: "Não reembolsável",
    shortFree: "Cancelamento grátis",
    shortDayPenalty: "Grátis até a chegada · depois {pct}%",
    shortUntilPenalty: "Grátis até 1 dia antes · depois {pct}% | Grátis até {count} dias antes · depois {pct}%",
  },
  cancellationPolicyLabel: "Política de cancelamento",
  policyEmpty: "Nenhuma política definida",
  policyEdit: "Editar",
  policyAdd: "Adicionar",
  defaultLabel: "Padrão",
  rulesApartment: "Regras: pelo menos 1 visível e 1 padrão (que deve estar visível).",
  rulesRoom: "Cada quarto deve ter pelo menos 1 tarifa visível e 1 padrão.",
  tip: 'Dica: defina uma tarifa "Flexível" como padrão e mostre outras como "Não reembolsável".',
  room: {
    ratePlansCount: "{count} tarifa | {count} tarifas",
    includedGuestsTitle: "Quantos hóspedes o preço inclui (para a cobrança por hóspede adicional)",
    includes: "Inclui",
    person: "hóspede | hóspedes",
    meta: "Capacidade: {capacity} • Adultos: {adults} • Crianças: {children}",
  },
  modal: {
    eyebrow: "Política de cancelamento",
    closeAria: "Fechar",
    hint: "Este texto será exibido ao hóspede na reserva direta. Descreva os termos de cancelamento desta tarifa.",
    textareaPlaceholder:
      "Ex.: Cancelamento gratuito até 48h antes do check-in. Depois disso, cobra-se a primeira noite. Não reembolsável na alta temporada.",
    clear: "Limpar",
    cancel: "Cancelar",
    saving: "Salvando…",
    save: "Salvar política",
    defaultTitle: "Tarifa",
  },
  toasts: {
    loadError: "Não foi possível carregar as tarifas.",
    saveSuccess: "Tarifas salvas com sucesso.",
    saveError: "Não foi possível salvar as tarifas.",
  },
  validation: {
    roomMinVisible: 'O quarto "{name}" deve ter pelo menos 1 tarifa visível.',
    roomOneDefault: 'O quarto "{name}" deve ter exatamente 1 tarifa padrão.',
    roomDefaultVisible: 'Em "{name}", a tarifa padrão deve estar visível.',
    minVisible: "Você deve manter pelo menos 1 tarifa visível.",
    oneDefault: "Deve haver exatamente 1 tarifa padrão.",
    defaultVisible: "A tarifa padrão deve estar visível.",
  },
};
